import { render, staticRenderFns } from "./PublishMsg.vue?vue&type=template&id=47893454&scoped=true&"
import script from "./PublishMsg.vue?vue&type=script&lang=js&"
export * from "./PublishMsg.vue?vue&type=script&lang=js&"
import style0 from "./PublishMsg.vue?vue&type=style&index=0&id=47893454&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47893454",
  null
  
)

export default component.exports